const signalR = require('@aspnet/signalr');
import config from '../config'
// import router from '../router'
import auth from './auth'
import Vue from 'vue';
// import _ from 'lodash';
export const EventBus = new Vue();
function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseSignalR;
    // case 'development' : return 'https://api.f1secaas.net';
    default : return `${location.protocol}//${location.hostname.replace(/^[^\\.]*\./, 'ws.')}`;
  }
}
const baseUrl = getApiHost();

let _connection = undefined;
let _retry = 0;
let events = []
let subscribe_events = []
let publish_events = []

let start = (hub, close, fail) => {
  if(_connection && _connection.connectionState == signalR.HubConnectionState.Connected) {
    return rv;
  }
  if(!_connection) {
    _retry = 0;
    _connection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseUrl}/${hub}`, { accessTokenFactory: () => auth.token, skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
      .build();
  } else {
    if(_retry++ > 30) { if(fail && typeof(fail) === 'function') { fail(); } return rv; }
  }
  _connection.onclose(async () => {
    console.log('[svc] signalr', 'closed');
    if(!_connection) {
      setTimeout(() => start(hub), 5000);
      console.log("started new signalr reconnecting ")

      if(close && typeof(close) === 'function') {
        close() && console.log("signalr real closed ")
      }
    }
  });
  if(_connection.connectionState == signalR.HubConnectionState.Disconnected) {
    console.log('[svc] signalr', 'disconnected', new Date(), events.length);
    if(events && events.length) {
      // 비동기 이므로 연결 대기중인 이벤트 등록
      for (let l = 0; l < events.length; l++) {
        _connection.on(events[l][0], events[l][1])
      }
      events = []
    }

    _connection.start()
    .then(() => {
      console.log('[svc] signalr', 'connected')
      _retry = 0;
    })
    .catch(e => {
      console.log('[svc] signalr', 'err', e);
      setTimeout(() => start(hub), 5000);
    })
  }
  return rv;
}

let stop = () => { _connection && _connection.stop(); _connection = undefined; }
const rv = {
  is_connected : () =>  { return _connection && _connection.connectionState == signalR.HubConnectionState.Connected },
  on : (k, f) => {
    let duplicate = false

    for (let i = 0; i < events.length; i++) {
      if(events[i][0] == k && k != 'webcastle') {
        console.log(events[i][0], events[i])
        duplicate = true
        continue
      }
    }
    // console.log('[svc] signalr', 'events', events. duplicate, _connection ? _connection.methods : '')
    if(duplicate == false) {
      if(_connection) { _connection.on(k, f) }
      events.push([k, f])
    }

    // console.log([k, f], events)
    // console.log(_connection && _connection.methods)
    return rv;
  },
  off : (k, f) => { _connection && _connection.off(k, f); return rv; },
  start : start,
  stop : stop,
  socket: () => _connection,
  subscribe: (key, func) =>  {
    // console.log('[svc] signalr', 'subscribe', subscribe_events.length, _connection ? true : false)
    _connection && _connection.state ? EventBus.$on(key, func) : subscribe_events.push([key, func])
  },
  publish: (key, pl) => {
    try {
      // console.log('[svc] signalr', 'publish', publish_events.length, _connection ? true : false)

      for (let l = 0; l < subscribe_events.length; l++) {
        // console.log(EventBus._events[subscribe_events[l][0]], subscribe_events, subscribe_events[l], _connection, _connection.state)
        // console.log('EventBus._events', EventBus._events)
        if(EventBus._events[subscribe_events[l][0]]) { continue }

        EventBus.$on(subscribe_events[l][0], subscribe_events[l][1])
        // console.log('[svc] signalr', 'subscribe done', subscribe_events[l][0], subscribe_events.length, _connection ? true : false)
      }

      if(_connection && _connection.state && Object.keys(EventBus._events).indexOf(key) > -1) {
        // console.log('sss', 'emit!!!', key, EventBus._events)
        EventBus.$emit(key, pl)
      } else {
        publish_events.push([key, pl])
      }
    } catch (e) {
      console.log(e)
    }

  },
  invoke: (key, value) => _connection && _connection.connectionState == signalR.HubConnectionState.Connected && _connection.invoke(key, value),
  getEventBus: () => EventBus
};
export default rv

if(location.hostname == 'localhost') { window['signalr'] = rv; }
